import { InjectionToken } from '@angular/core';
import { TranslocoRootModule } from './transloco-root.module';

export interface LocalizeConfig {
  isProduction: boolean;
}

export const TRANSLOCO_FOR_ROOT_GUARD = new InjectionToken<TranslocoRootModule>('TRANSLOCO_FOR_ROOT_GUARD');

export const TRANSLATE = {
  LANGS_AVAILABLE: ['ru', 'en', 'es', 'fr', 'it', 'pl'],
  LANG_DEFAULT: 'ru',
  LANG_FALLBACK: ['en', 'ru'],
};
